<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalMap"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-width"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div class="card_title_1">
              <div style="display: flex" class="mbl-gen align-items-center">
                <template v-for="(item, index) in dataBread" :key="index">
                  <div
                    v-if="dataBread.length >= 4 && index + 1 == 1"
                    class="d-flex align-items-center"
                  >
                    <div class="breadcrumb_link_card" @click="toPath(item.id)">
                      {{ item.label }}
                    </div>
                    <div class="mx-2">
                      <img
                        src="@/assets/images/a/arrow.svg"
                        class="breadcrumb_arrow_card"
                      />
                    </div>
                  </div>

                  <div
                    v-if="dataBread.length >= 4 && index + 1 == 2"
                    class="d-flex align-items-center"
                  >
                    <div class="dropdown">
                      <div
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        class="breadcrumb_link_card"
                      >
                        ...
                      </div>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <template v-for="(i, idx) in dataBread" :key="idx">
                          <li>
                            <a
                              v-if="idx != 0 && idx + 1 != dataBread.length"
                              @click="toPath(item.id)"
                              class="dropdown-item breadcrumb_item_card"
                              >{{ i.label }}</a
                            >
                          </li>
                        </template>
                      </ul>
                    </div>
                    <div class="mx-2">
                      <img
                        src="@/assets/images/a/arrow.svg"
                        class="breadcrumb_arrow"
                      />
                    </div>
                  </div>

                  <div
                    v-if="
                      dataBread.length < 4 && index + 1 !== dataBread.length
                    "
                    class="d-flex align-items-center"
                  >
                    <div class="breadcrumb_link_card" @click="toPath(item.id)">
                      {{ item.label }}
                    </div>
                    <div class="mx-2">
                      <img
                        src="@/assets/images/a/arrow.svg"
                        class="breadcrumb_arrow_card"
                      />
                    </div>
                  </div>
                  <div
                    v-if="index + 1 === dataBread.length"
                    class="breadcrumb_text_card mt-1"
                  >
                    {{ item.label }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div
            style="
              display: flex;
              margin: calc(-0.5 * 1rem) calc(-0.5 * 1rem) calc(-0.5 * 1rem) auto;
            "
            class="modal-title"
          >
            <div style="align-content: center" class="card_title_2">
              Last Update: {{ last_update }}
            </div>
            <button
              style="margin: 0"
              type="button"
              class="btn-close"
              @click="closeModal"
            ></button>
          </div>
          <!-- <button type="button" class="btn-close" @click="closeModal"></button> -->
        </div>
        <div class="modal-body">
          <div class="row">
            <div
              style="background-color: #f2f2f2"
              class="col-md-3 container-card"
            >
              <span class="m-b-20 m-t-20"
                >Select a {{ regionTitle }} to drill down</span
              >
              <div
                v-for="(item, id) in dataRegion"
                :key="id"
                style="cursor: pointer"
                :class="{ clicked: item.clicked }"
                class="card card_white mb_12"
                @click="detailRegion(item)"
              >
                {{ item.label }}
              </div>
            </div>
            <div
              style="background: #fbfbfb"
              class="col-md-4 mt-mobile container-card"
            >
              <div
                v-for="(item, id) in dataList"
                :key="id"
                style="cursor: pointer; background: #fbfbfb"
                :class="{ clicked: item.clicked }"
                @click="detailItem(item)"
                class="card card_whites mb_12"
              >
                <div class="sub_title_2">
                  {{ item.metricName }} {{ item.currency }}
                </div>
                <div
                  style="justify-content: space-between"
                  class="d-flex align-items-center"
                >
                  <div class="data_text">{{ formattedNumber(item.value) }} {{ item.unit }}</div>
                  <div style="flex: 1; text-align: right" class="d-flex ms-2">
                    <div
                      @mouseenter="showTooltipArc"
                      @mouseleave="hideTooltipArc"
                      v-if="
                        item.metricId !== 'DISTRIBUTION_UNSAFE_ACT' &&
                        item.metricId !== 'DISTRIBUTION_UNSAFE_CONDITION' &&
                        item.metricId !== 'DISTRIBUTION_NEAR_MISS'
                      "
                      class="d-inline-flex align-items-center me-2 tooltip-container"
                      :class="
                        item.achievementStatus === 'DOWN'
                          ? 'badge_red'
                          : 'badge_green'
                      "
                    >
                      <div v-if="visibleArc" class="tooltip-content">
                        <span>Achievement</span>
                      </div>
                      <IconSvg
                        :color="
                          item.achievementStatus === 'DOWN' ? 'red' : 'green'
                        "
                        :type="
                          item.achievementStatus === 'DOWN'
                            ? 'arrow_down'
                            : 'arrow_up'
                        "
                      />
                      <div
                        class="data_detil"
                        :style="
                          item.achievementStatus === 'DOWN'
                            ? 'color: red'
                            : 'color:green'
                        "
                      >
                        {{ item.achievement === null ? 0 : item.achievement }}
                      </div>
                    </div>
                    <div
                      @mouseenter="showTooltip"
                      @mouseleave="hideTooltip"
                      class="d-inline-flex align-items-center tooltip-container"
                      :class="
                        item.trendStatus === 'DOWN'
                          ? 'badge_red'
                          : 'badge_green'
                      "
                    >
                      <div
                        style="left: 60px !important"
                        v-if="visible"
                        class="tooltip-content"
                      >
                        <span>Trend</span>
                      </div>
                      <IconSvg
                        :color="item.trendStatus === 'DOWN' ? 'red' : 'green'"
                        :type="
                          item.trendStatus === 'DOWN'
                            ? 'chart_down'
                            : 'chart_up'
                        "
                      />
                      <div
                        class="data_detil"
                        :style="
                          item.trendStatus === 'DOWN'
                            ? 'color: red'
                            : 'color:green'
                        "
                      >
                        {{ item.trend === null ? 0 : item.trend }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <svg
                      v-if="item.clicked || hoverIndex === id"
                      class="icon-svg m-l-30"
                      :class="{ clicked: item.clicked }"
                    >
                      <use
                        href="@/assets/svg/icon-sprite.svg#arrow-right-blue"
                      ></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div
                style="display: flex"
                class="mbl-gen justify-content-between"
              >
                <div>
                  <button
                    @click="monthly"
                    style="border-radius: 10px"
                    class="btn btn-square btn-disable"
                    :class="{ 'btn-info': !isActiveMonth }"
                    type="button"
                    title="btn btn-square btn-primary"
                  >
                    Monthly
                  </button>
                  <!-- <button
                    @click="monthly"
                    :class="{ 'btn-info': isActiveMonth }"
                    class="btn btn-square btn-disable m-r-10"
                    type="button"
                    title="btn btn-square btn-primary"
                  >
                    Year
                  </button> -->
                </div>
                <div>
                  <div class="d-flex checkbox-solid-primary">
                    <span
                      class="m-r-10"
                      style="
                        color: white;
                        font-weight: bold;
                        padding: 0px 8px 0px 8px;
                        border-radius: 8px;
                        background-color: #ff5151;
                      "
                      >x</span
                    >
                    <span
                      style="align-self: center"
                      class="text-center m-r-5 custom_checkbox_texts"
                      >No. of Outages</span
                    >
                  </div>
                </div>
              </div>
              <apexchart
                type="bar"
                ref="chart"
                height="450"
                :options="chartOptions"
                :series="series"
                @dataPointSelection="handleDataPointSelection"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalDetailChartVue
      :showModal="modalMap.show"
      :dataMaps="dataMaps"
      :dataPoint="dataPoint"
      @closeModal="onCloseModalMap"
    />
  </div>
</template>

<script>
import _ from "lodash";
import IconSvg from "@/components/IconSvg.vue";
import DistributionService from "@/services/distribution/distribution";
import ModalNetwortMapChartVue from "./ModalNetwortMapChart.vue";
import ModalDetailChartVue from "./ModalDetailChart.vue";
import { formattedNumber } from "@/utils/helper";
const apiDistribution = DistributionService.build();
export default {
  components: { ModalNetwortMapChartVue, ModalDetailChartVue, IconSvg },
  props: ["distribution", "showModal", "dataMap", "titleNetwork"],
  data() {
    return {
      last_update: "asd",
      visible: false,
      visibleArc: false,
      modalMap: {
        show: false,
        load: false,
      },
      dataMaps: [],
      isActiveMonth: false,
      titleNetworks: "",
      dataNetworkDetail: [],
      modalMap: {
        show: false,
        load: false,
      },
      regionTitle: "",
      modal: null,
      dataList: [],
      titleSub: "",
      dataBread: [],
      dataRegion: [],
      series: [],
      chartOptions: {
        chart: {
          events: {
            dataPointSelection: (event, chartContext, config) => {},
            selection: function (chartContext, { xaxis, yaxis }) {
              // ...
            },
            markerClick: function (event, chartContext, opts) {
              // ...
            },
            click: function (event, chartContext, opts) {
              // The last parameter opts contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
            },
          },
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: this.dataLabel,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#ff5151"],
            backgroundColor: "#ff5151",
            padding: {
              left: 10, // Example padding values, adjust as needed
              right: 10,
              top: 10,
              bottom: 10,
            },
          },
          background: {
            enabled: true,
            foreColor: "#fff",
            borderRadius: 10,
            borderWidth: 1,
            borderColor: "#ff5151",
            opacity: 0.9,
            dropShadow: {
              enabled: false,
              top: 1,
              left: 1,
              blur: 1,
              color: "#fff",
              opacity: 0.45,
            },
          },
        },

        xaxis: {
          categories: [],
          position: "bottom",
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
          labels: {
            show: true,
            style: {
              colors: "#7A7A7A",
              fontFamily: "Rubik, sans-serif",
            },
          },
        },
        tooltip: {
          enabled: true,
          shared: false,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return (
              '<div class="custom-tooltip">' +
              "<span>" +
              w.globals.labels[dataPointIndex] +
              "</span><br/><hr/>" +
              "<span>" +
              series[seriesIndex][dataPointIndex] +
              "</span>" +
              "</div>"
            );
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            // formatter: function (val) {
            //   let str = val.toString();
            //   let first = str.slice(0, 2);
            //   return val;
            // },
          },
        },
        title: {
          floating: true,
          offsetY: 330,
          align: "center",
          style: {
            color: "#444",
          },
        },
      },
      dataOut: [],
      tempData: [],
      idDataList: "",
      idRegion: "",
      dataOutages: [],
      dataPoint: "",
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalMap);
  },

  methods: {
    formattedNumber,
    showTooltip() {
      this.visible = true;
    },
    hideTooltip() {
      this.visible = false;
    },
    showTooltipArc() {
      this.visibleArc = true;
    },
    hideTooltipArc() {
      this.visibleArc = false;
    },
    handleDataPointSelection(event, chartContext, config) {
      this.dataPoint = config.dataPointIndex;
      this.dataMaps = this.dataOutages;
      this.modalMap.show = true;
      // Handle your click event here
    },
    onCloseModalMap(value) {
      this.modalMap.show = value;
    },
    dataLabel(value, opt) {
      return this.dataOut[opt.dataPointIndex];
    },
    clickHandler(event, config, opt) {},
    getLabel(value) {
      this.chartOptions.dataLabels = 60;
      this.$refs.chart.updateOptions({
        dataLabels: this.chartOptions.dataLabels,
      });
    },
    detailRegion(x) {
      this.getDataDetail(x.id);
    },
    toPath(x) {
      this.getDataDetail(x);
    },
    async getDataDetail(x) {
      // this.dataBread = [];
      let data = this.dataMap;
      let param = Object.assign({
        metricId: x === undefined ? data.instanceId : x,
        instance: "",
        groupBy: "",
      });
      const res = await apiDistribution.getDataDistributionDetailMap(param);
      this.last_update = res.data.lastUpdate;
      const datas = res.data.data;
      this.tempData = datas;
      // const bread = datas.currentInstances;
      const bread = datas.currentInstances;
      const list = datas.childInstances;
      this.dataList = datas.metrics;
      this.detailItem(datas.metrics[0]);
      this.dataBread = bread;
      const last = list[list.length - 1];
      if (last !== undefined) {
        if (last.label.includes("UID")) {
          this.regionTitle = "UID & UIW";
        } else if (last.label.includes("UIW")) {
          this.regionTitle = "UID & UIW";
        } else if (last.label.includes("UP3")) {
          this.regionTitle = "UP3";
        } else if (last.label.includes("ULP")) {
          this.regionTitle = "ULP";
        } else if (
          !last.label.includes("ULP") &&
          !last.label.includes("UP3") &&
          !last.label.includes("UIW")
        ) {
          this.regionTitle = "REGION";
        } else {
          this.regionTitle = "REGION";
        }
      } else {
        return false;
      }
      this.dataRegion = datas.childInstances;
      // this.getDataDetailMetric(datas);
    },
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
      this.getDataDetailMetric(this.tempData);
    },
    detailItem(x) {
      this.dataList.forEach((e) => {
        if (e.metricId === x.metricId) {
          e.clicked = true;
          this.idDataList = x.metricId;
          this.getDataDetailMetric(this.tempData);
        } else {
          e.clicked = false;
        }
      });
    },
    async getDataDetailMetric(value) {
      let param = Object.assign({
        metricId:
          this.idDataList !== "" ? this.idDataList : value.metrics[0].id,
        instance:
          value.childInstances.length > 0 ? value.childInstances[0].id : "",
        periodType: this.isActiveMonth ? "annually" : "monthly",
      });
      const res = await apiDistribution.getDataDetailMetric(param);
      const datas = res.data.data;
      this.chartOptions = { xaxis: { categories: datas.labels } };
      this.series = [
        {
          name: "",
          data: datas.values,
          dataOut: datas.outagesValues,
        },
      ];
      this.dataOutages = datas.outages;
      this.dataOut = datas.outagesValues;
      // this.getLabel(datas.outagesValues);
    },
    onCloseModalMap(value) {
      this.modalMap.show = value;
    },
    detailChart() {
      this.titleNetworks = "Kalimantan Barat";
      this.modalMap.show = true;
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
  },

  watch: {
    async showModal() {
      if (this.showModal) {
        this.getDataDetail();
        // const data = this.distribution;
        // const merges = _.unionBy(
        //   data.efficiency,
        //   data.quality,
        //   data.realibity,
        //   data.safety
        // );
        // this.dataList = merges;
        // const ef = data.map((obj) => obj.effeciency)
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
};
</script>

<style lang="scss">
.custom_header {
  padding: 1rem 1rem 0rem 1rem;
  border-bottom: unset;

  .custom_header_content {
    width: 100%;
    position: relative;

    .close_btn {
      position: absolute;
      right: 0;
      z-index: 999;
    }

    .tahun_text {
      font-size: 20px;
      font-weight: 400;
      line-height: 23px;
    }

    .judul_text {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
    }
  }
}

.custom-modal-width {
  max-width: 564px;
  width: 100%;
}

.tabs {
  color: #838383;
  font-size: 14px;
  padding: 5px;
  cursor: pointer;
}

.tabs_active {
  color: #00a3e9;
  border-bottom: 3px solid #00a3e9;
}

.custom_pb {
  background: unset !important;
  height: 8px;
}
.clicked {
  border-color: #00a3e9 !important;
  background-color: #ecf9ff !important;
}
.custom-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
